<div class="login-shell">
  <section class="login-showcase" aria-label="InnovaCare Clinical platform introduction">
    <img class="login-showcase__image" src="assets/ChatGPT Image 28 mai 2026, 18_29_54.png" alt="Innovacare Clinical team" />
    <div class="login-showcase__scrim"></div>
    <div class="login-showcase__glow" aria-hidden="true"></div>
    <div class="login-showcase__content">
      <div class="login-brand">
        <span class="login-brand__mark">
          <span></span>
          <span></span>
        </span>
        <div>
          <strong>InnovaCare Clinical</strong>
          <small>CONNECTED CLINICAL WORK</small>
        </div>
      </div>

      <div class="login-showcase__copy">
        <p class="login-showcase__eyebrow">CONNECTED CARE · SECURE WORKSPACE</p>
        <h1>Clinical care, thoughtfully connected.</h1>
        <p>
          Coordinate wound care, documentation, telehealth, scheduling, and team workflows within one protected clinical platform.
        </p>
      </div>

      <div class="login-showcase__highlights">
        <article>
          <strong>Role-based access</strong>
          <span>The right clinical workspace for each authorized team member.</span>
        </article>
        <article>
          <strong>Clinical coordination</strong>
          <span>Wound surveillance, referrals, and coordinated follow-up.</span>
        </article>
        <article>
          <strong>Connected operations</strong>
          <span>From bedside documentation to provider review and reporting.</span>
        </article>
      </div>
    </div>
  </section>

  <section class="login-panel">
    <div class="login-panel__ambient" aria-hidden="true"></div>
    <div class="login-card">
      <div class="login-card__header">
        <p class="login-card__eyebrow">Sign in</p>
        <h2>Welcome to InnovaCare Clinical</h2>
        <p>Sign in securely to your organization’s clinical workspace.</p>
      </div>

      <form class="login-form" (ngSubmit)="login()">
        <label class="login-field">
          <span>Work email</span>
          <input type="email" name="email" [(ngModel)]="email" placeholder="name@organization.com" required />
        </label>

        <label class="login-field">
          <span>Password</span>
          <input type="password" name="password" [(ngModel)]="password" placeholder="Enter your password" required />
        </label>

        <div *ngIf="errorMsg" class="login-alert" role="alert">
          {{ errorMsg }}
        </div>

        <button type="submit" class="login-submit" [disabled]="loading">
          {{ loading ? 'Signing in...' : 'Sign in' }}
        </button>
      </form>

      <div class="login-card__footer">
        <p>Authorized users only · Access is assigned by your organization.</p>
        <p>Forgot your password? Contact your administrator to reset it.</p>
        <a href="#/innovacare-clinical/contact">Need access, a demo, or a deployment?</a>
      </div>
    </div>
  </section>
</div>